"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ArrowDownward = function ArrowDownward(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.84,18.64l5.53-5.46.26-.25a1.22,1.22,0,0,0,0-1.75,1.28,1.28,0,0,0-1.78,0l-3.64,3.6V6.24a1.26,1.26,0,0,0-2.52,0v8.54L7.15,11.31a1.26,1.26,0,0,0-1.78,0,1.19,1.19,0,0,0-.37.87,1.25,1.25,0,0,0,.32.82l0,.05,5.69,5.59A1.28,1.28,0,0,0,12.84,18.64Z"
  }));
};

var _default = ArrowDownward;
exports["default"] = _default;